export const questionTypes = [
  { value: "TEXTBOX", label: "Textbox" },
  { value: "UPLOAD", label: "File" },
  { value: "DROPDOWN", label: "Dropdown" },
  { value: "RADIO", label: "Single-Select" },
  { value: "CHECKBOX", label: "Multi-Select" },
  { value: "CALENDAR", label: "Date" },
  { value: "NUMERIC", label: "Number" },
  { value: "PHONE", label: "Phone Number" },
  { value: "BOOLEAN", label: "Boolean" },
];

const validQuestionTypes = questionTypes.map((qt) => qt.value);

export const sanitizeQuestionType = (type) => {
  // If type is undefined or null, return default
  if (!type) return "TEXTBOX";
  
  // Convert to uppercase
  const upperType = type.toUpperCase();
  
  // Return the type if it's valid, otherwise return default
  return validQuestionTypes.includes(upperType) ? upperType : "TEXTBOX";
};
